import { z } from 'zod';
import { PermissionSchema, RoleSchema, RowVersionSchema, ViewKeySchema } from './common.schema';

/**
 * The access matrix is runtime editable by Management, section 4.2.
 *
 * `PUT /access-matrix` is a full replacement carrying a rowVersion, and the
 * server rejects with 422 any payload that removes `users` from `management`.
 * Otherwise an administrator can lock every user out of the system with one
 * checkbox and there is no way back in without a database edit.
 */
export const AccessMatrixSchema = z.object({
  roles: z.array(z.object({ key: RoleSchema, label: z.string() })),
  permissions: z.array(
    z.object({
      key: PermissionSchema,
      label: z.string(),
      roles: z.array(RoleSchema),
    }),
  ),
  views: z.array(
    z.object({
      key: ViewKeySchema,
      label: z.string(),
      roles: z.array(RoleSchema),
      locked: z.boolean().optional(),
    }),
  ),
  rowVersion: RowVersionSchema,
});

export type AccessMatrix = z.infer<typeof AccessMatrixSchema>;
